import classNames from 'classnames';
import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { AdvertFuse } from 'components/advert/advert-fuse.js';
import { displayShowWhenHideWhenLabel } from 'layout/utils-show-hide.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { IAdvertisingConfigRaw } from 'redux-state/advertisement/types.js';
import { IRepoState } from 'redux-state/rootReducer.js';

export const AdvertSkins = ({ children, skin }: { children: JSX.Element; skin: IAdvertisingConfigRaw['skin'] }) => {
  const isTabletOrAbove = useContext(ColumnLayoutContext) !== '1-column';
  const isPageLoading = useSelector((state: IRepoState) => state.LOADING.isLoading);
  const _addOverlayClass = useSelector((state: IRepoState) => state.APP.overlayOpen);
  const columnLayout = useContext(ColumnLayoutContext);
  const addOverlayClass = _addOverlayClass || isPageLoading;
  const display = displayShowWhenHideWhenLabel(skin?.layout, columnLayout);

  /** We have already updated the skin target data so we do not want to override so we use overrideBaseTargeting={true} */
  return (
    <>
      {display && isTabletOrAbove && skin?.left && (
        <div className={classNames('Skin Skin--left', { 'has-overlay': addOverlayClass })}>
          <AdvertErrorBoundary>
            <AdvertFuse
              fuseTag={skin.left.fuseTag}
              adUnitPath={skin.left.adUnitPath}
              targeting={skin.targeting}
              origin="adv-SkinLeft"
            />
          </AdvertErrorBoundary>
        </div>
      )}

      {children}

      {display && isTabletOrAbove && skin?.right && (
        <div className={classNames('Skin Skin--right', { 'has-overlay': addOverlayClass })}>
          <AdvertErrorBoundary>
            <AdvertFuse
              fuseTag={skin?.right.fuseTag}
              adUnitPath={skin?.right.adUnitPath}
              targeting={skin?.targeting}
              origin="adv-SkinRight"
            />
          </AdvertErrorBoundary>
        </div>
      )}
    </>
  );
};
